import { env } from '../config/env';

/**
 * Where a guest goes to redeem a retrieval code.
 *
 * The kiosk prints this on screen, so it has to be the public host a guest can
 * type on their own phone — not the kiosk's own origin, which on the APK is a
 * file:// or localhost shell. Hence an explicit env var, with the current host
 * as a sane default for browser testing.
 */
export function clipCodeHost(): string {
  const configured = env.clipCodeHost.trim();
  if (configured) return configured.replace(/^https?:\/\//i, '').replace(/\/+$/, '');
  if (typeof window !== 'undefined' && window.location.host) return window.location.host;
  return '';
}

/** The full URL a code resolves to. */
export function clipCodeUrl(code: string): string {
  const host = clipCodeHost();
  return host ? `https://${host}/c/${code}` : `/c/${code}`;
}
